import { createFileRoute, notFound } from "@tanstack/react-router";
import { buildPageHead } from "@/lib/seo";
import HubTag from "@/pages/HubTag";

// Cross-type tag page: everything carrying the tag, whatever its type.
export const Route = createFileRoute("/hub/$tag")({
  // The library dataset is imported lazily so it stays out of the entry
  // bundle; only the small head fields are returned (they get serialized
  // into the SSR payload).
  loader: async ({ params }) => {
    const { getTag, getPostsByTag } = await import("@/data/library");
    const tag = getTag(params.tag);
    if (!tag) throw notFound();
    // A tag with no posts would render an empty page — 404 instead so thin
    // pages never get indexed.
    if (getPostsByTag(tag.slug).length === 0) throw notFound();
    return {
      title: tag.seoTitle ?? `${tag.name} | Bigdelta`,
      description: tag.blurb,
      slug: tag.slug,
    };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    return buildPageHead({
      title: loaderData.title,
      description: loaderData.description,
      path: `/hub/${loaderData.slug}`,
    });
  },
  component: HubTag,
});
